import { GOOGLE_FORM_API } from '../config';

/**
 * Submits form data to a Google Form
 * @param formEntries An object containing Google Form entry IDs as keys and form values as values
 */
export const submitToGoogleForm = async (formEntries: Record<string, string>) => {
  // Convert form entries to URL params
  const urlParams = new URLSearchParams();
  Object.entries(formEntries).forEach(([key, value]) => {
    urlParams.append(key, value);
  });

  try {
    const response = await fetch(GOOGLE_FORM_API, {
      method: 'POST',
      mode: 'no-cors', // This is required but means we can't check the response status
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: urlParams,
    });

    // console.log('Form response: ', response);

    return true;
  } catch (error) {
    console.error('Error submitting to Google Form:', error);
  }
};
